import React, { Component } from 'react'
import Car from '../NewCars/NewCars'

class NewMyCars extends Component {
    render() {
        return (
            <div>
                <h1 className="text-center">hello React</h1>
                <Car color="red"> Ford </Car>
                <Car color="black"> Mercedes </Car>
                <Car color="blue" trucmuch='caca' abruti='border border-white rounded-lg'> Peugeot </Car>
            </div>
        )
    }
}

export default NewMyCars
